// extracted by mini-css-extract-plugin
export default {"backLink":"BackButton_backLink__PDBUh","icon":"BackButton_icon__n8Mkp"};